// ── Light palette (inspired by SJ design language) ──────────────────────────

export const lightPalette = {
  primary: {
    main: "#007729", // AA contrast override (BUG-005) — 5.72:1 with #fff
    light: "#33BB62",
    dark: "#007729",
    contrastText: "#fff",
  },
  secondary: {
    main: "#E8F7E4",
    light: "#ECF8E9",
    dark: "#A2AC9F",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  error: {
    main: "#DE1F26",
    light: "#E44B51",
    dark: "#9B151A",
    contrastText: "#fff",
  },
  warning: {
    main: "#FFD700",
    light: "#FFDF33",
    dark: "#B29600",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  info: {
    main: "#22BCE8",
    light: "#4EC9EC",
    dark: "#1783A2",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  success: {
    main: "#00AB3B",
    light: "#33BB62",
    dark: "#007729",
    contrastText: "#fff",
  },
  background: {
    default: "#fff",
    paper: "#fff",
  },
  text: {
    primary: "#000000",
    secondary: "rgba(0, 0, 0, 0.6)",
  },
} as const;

// ── Dark palette (DEM-039) ──────────────────────────────────────────────────

export const darkPalette = {
  primary: {
    main: "#33BB62", // lighter green for dark bg — 5.2:1 contrast on #121212
    light: "#66D48E",
    dark: "#007729",
    contrastText: "#000",
  },
  secondary: {
    main: "#1B3A1F",
    light: "#2A5430",
    dark: "#0D1F11",
    contrastText: "rgba(255, 255, 255, 0.87)",
  },
  error: {
    main: "#E44B51",
    light: "#EF7A7E",
    dark: "#9B151A",
    contrastText: "#fff",
  },
  warning: {
    main: "#FFD700",
    light: "#FFDF33",
    dark: "#B29600",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  info: {
    main: "#4EC9EC",
    light: "#7DD8F1",
    dark: "#1783A2",
    contrastText: "rgba(0, 0, 0, 0.87)",
  },
  success: {
    main: "#33BB62",
    light: "#66D48E",
    dark: "#007729",
    contrastText: "#000",
  },
  background: {
    default: "#121212",
    paper: "#1e1e1e",
  },
  text: {
    primary: "#ffffff",
    secondary: "rgba(255, 255, 255, 0.7)",
  },
} as const;

// Backwards-compatible alias
export const palette = lightPalette;

// ── Typography constants ────────────────────────────────────────────────────

export const typography = {
  fontFamily: "sj_sans, arial, sans-serif",
  fontFamilyBold: "sj_sans_bold, arial, sans-serif",
  fontFamilyMedium: "sj_sans_medium, arial, sans-serif",
  fontFeature: '"liga" on, "dlig" on, "tnum" off',
  fontFeatureH1: '"liga" off, "dlig" on, "tnum" off',
} as const;

// ── Spacing & shape ─────────────────────────────────────────────────────────

export const spacing = 8;
export const shape = { borderRadius: 4 } as const;
